import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {ExpenseRequest} from 'main/stores/expenses';

class ExpenseRequestDetailsState {
  store = new DomainStore();
  history;
  match;

  request;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  async load() {
    await this.store._compose([endpoints.EXPENSES.REQUEST.with(this.match.params.id)]);
    this.request = new ExpenseRequest(
      this.store._getSingle(types.EXPENSES.REQUEST, {id: this.match.params.id})
    );
  }

  async approve() {
    const {model, errors} = await this.store.patch(
      this.request.link('approve'),
      types.EXPENSES.REQUEST,
      {actionedNotes: this.request.actionedNotes}
    );

    this.errors = errors;

    if (model) {
      this.goBack(`${t('expenses.expense_requests.detail.Request approved')}`);
    }
  }

  async reject() {
    const {model, errors} = await this.store.patch(
      this.request.link('reject'),
      types.EXPENSES.REQUEST,
      {actionedNotes: this.request.actionedNotes}
    );

    this.errors = errors;

    if (model) {
      this.goBack(`${t('expenses.expense_requests.detail.Request rejected')}`);
    }
  }

  goBack(alert) {
    let path = this.backButtonDetails.backPath;

    if (alert) {
      path += `?alert=${alert}`;
    }

    this.history.push(path);
  }

  get backButtonDetails() {
    const {backPath} = this.match.params;

    if (backPath === 'my_expenses') {
      return {
        backPath: '/',
        backTitle: t('expenses.subnav.My Expenses')
      };
    } else {
      return {
        backPath: '/expense_requests',
        backTitle: t('expenses.subnav.Expense Requests'),
      };
    }
  }
}

export default ExpenseRequestDetailsState;
